module.exports = __webpack_public_path__ + "img/MultipleUsers.ef7426c1.svg";